import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const target = this.element.getAttribute("data-target");
    this.element.addEventListener("click", () => {
      const targetElement = document.getElementById(target);
      const input = targetElement.querySelector("input");
      if (this.element.classList.contains("on")) {
        targetElement.classList.add("hidden");
        this.element.classList.remove("on");
        // Clear the input value
        if (input) {
          input.value = "";
        }
      } else {
        targetElement.classList.remove("hidden");
        this.element.classList.add("on");
        // Focus on the first input element in the target element
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 1);
        }
      }
    });
  }
}
